import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { base, clinicId } from "../../../../constants";
import { MasterTableDataType, SearchParamsType } from "./type";
import { getPriceMastersTableData } from "../service";
import { useQuery } from "react-query";
import moduleRoutes from "../../../../routes/moduleRouteList";
import mastersRouteList from "../../../routeList";
import insuanceMatserRouteList from "../../routeList";
import {
  Divider,
  IconButton,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import CustomTableBody from "../../../../utilis/component/CustomTableBody";
import {
  CheckBox,
  CheckBoxOutlineBlank,
  CheckBoxOutlineBlankOutlined,
  Edit,
  NoteAdd,
} from "@mui/icons-material";
import AddOrEdit from "./AddOrEdit";

function insurancePriceList() {
  const pageTitle = "Insurance Price ";
  const formContainerRef = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useState<SearchParamsType>({
    pageNumber: 0,
    pageSize: 25,
    sortField: "",
    sortOrder: "",
    clinicId: clinicId,
  });
  const [data, setData] = useState<MasterTableDataType | null>(null);
  const [success, setSuccess] = useState<boolean>(false);

  const { data: tableData, isLoading: tableDataLoading } = useQuery(
    ["", searchParams, success],
    async () => getPriceMastersTableData(searchParams),
    {
      refetchOnWindowFocus: false,
    }
  );

  const handleChangePage = (
    _: React.MouseEvent<HTMLButtonElement> | null,
    pageNumber: number
  ) => {
    setSearchParams((prev) => ({
      ...prev,
      pageNumber,
    }));
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setSearchParams((prev) => ({
      ...prev,
      page: 0,
      pageSize: parseInt(event.target.value, 10),
    }));
  };

  const handleNavigateClick = (data?: MasterTableDataType) => {
    navigate(
      `${base}${moduleRoutes.mainRoute}/${moduleRoutes.masters}/${mastersRouteList.insuranceMaster}/${insuanceMatserRouteList.insurancePriceMaster}/${insuanceMatserRouteList.PriceRateEdit}`,
      { state: { data: data || null } }
    );
  };
  return (
    <div className="p-3">
      <div ref={formContainerRef}></div>
      <Paper>
        <div className="flex justify-between p-3">
          <div className="flex gap-2">
            <Typography variant="h6" color={"default"}>
              {pageTitle} Master
            </Typography>
          </div>
        </div>
        <Divider />
        <div className="">
          <div className="">
            <AddOrEdit
              data={data as MasterTableDataType}
              setData={setData}
              setSuccess={setSuccess}
              success={success}
            />
          </div>
          <TableContainer className="border">
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  {headings.map((heading) => (
                    <TableCell key={heading} className="font-bold">
                      {heading}
                    </TableCell>
                  ))}
                  <TableCell className="font-bold">Actions</TableCell>
                </TableRow>
              </TableHead>
              <CustomTableBody
                alert={"No data"}
                dataLoading={tableDataLoading}
                isData={Boolean(tableData?.response?.items?.length)}
                totalSpan={{
                  row: searchParams.pageSize,
                  col: headings.length + 2,
                }}
              >
                {tableData?.response?.items?.map((tableItem, index) => (
                  <TableRow key={`${pageTitle}-${index}`}>
                    <TableCell>{tableItem?.insType}</TableCell>
                    <TableCell>{tableItem?.insName} </TableCell>
                    <TableCell>
                      {tableItem?.insGroup != null
                        ? tableItem?.insGroup
                        : tableItem?.insName}{" "}
                    </TableCell>
                    <TableCell>{tableItem?.insNetwork} </TableCell>
                    <TableCell>{tableItem?.insPlan} </TableCell>
                    <TableCell>{tableItem?.cptGrp} </TableCell>
                    <TableCell>{tableItem?.effectiveFromDate} </TableCell>
                    <TableCell>{tableItem?.factor} </TableCell>
                    <TableCell>
                      {tableItem?.isExcluded ? (
                        <CheckBox color="info" />
                      ) : (
                        <CheckBoxOutlineBlankOutlined />
                      )}{" "}
                    </TableCell>
                    <TableCell>
                      {tableItem?.common ? (
                        <CheckBox color="info" />
                      ) : (
                        <CheckBoxOutlineBlank />
                      )}{" "}
                    </TableCell>
                    <TableCell>
                      {tableItem?.approvalRequired ? (
                        <CheckBox color="info" />
                      ) : (
                        <CheckBoxOutlineBlank />
                      )}{" "}
                    </TableCell>
                    <TableCell>
                      <div className="flex gap-2">
                        <IconButton
                          color="primary"
                          onClick={() => {
                            if (formContainerRef.current) {
                              formContainerRef.current.scrollIntoView({
                                behavior: "smooth",
                              });
                            }
                            setData((prev) => ({ ...prev, ...tableItem }));
                          }}
                        >
                          <Edit />
                        </IconButton>
                        <IconButton
                          color="primary"
                          onClick={() => {
                            handleNavigateClick(tableItem);
                          }}
                        >
                          <NoteAdd />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </CustomTableBody>
            </Table>
            <div className="flex justify-end">
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component={"div"}
                count={tableData?.response?.totalCount || 0}
                rowsPerPage={searchParams.pageSize}
                page={searchParams.pageNumber}
                sx={{ border: 0 }}
                slotProps={{
                  select: {
                    inputProps: {
                      "aria-label": "rows per page",
                    },
                    native: true,
                  },
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          </TableContainer>
        </div>
      </Paper>
    </div>
  );
}

export default insurancePriceList;

const headings = [
  "Insurance Type",
  "Insurance Name",
  "Insurance Group",
  "Insurance Network",
  "Insurance Plan",
  "CPT Group",
  "Effective From Date",
  "Factor",
  "Is Excluded",
  "Common",
  "Approval Required",
];
